import dayjs from "dayjs";
import { resolvePeriod } from "@/ui/components/date/dateRangeValidation";
import ActiveFilterDTO = App.Data.Explorer.Filter.ActiveFilterDTO;

export function activeFiltersDisplay(filter: ActiveFilterDTO) {
	if (filter.dimension.type === "hierarchy") {
		return filter.values
			.map(function (value) {
				let txt = value.label;
				// Make sure the excluded branch is actually a sublevel of the selected value.
				const excludedBranches = (value.excluded_branches || []).filter(
					(excludedBranch) => excludedBranch.level < value.level
				);

				if (excludedBranches.length > 0) {
					txt +=
						" excluding " +
						value.excluded_branches
							.map((excludedBranch) => excludedBranch.label)
							.join(" or ");
				}
				return txt;
			})
			.join(" or ");
	}

	if (filter.dimension.type === "datetime") {
		const storedPeriod = filter.values[0]?.filter_period;
		if (storedPeriod) {
			const filterPeriod = resolvePeriod(storedPeriod);
			const from = filterPeriod.from
				? dayjs(filterPeriod.from_parsed).format("D-MMM-YYYY HH:mm")
				: null;
			const to = filterPeriod.to
				? dayjs(filterPeriod.to_parsed).format("D-MMM-YYYY HH:mm")
				: null;

			if (from && to) {
				return `between ${from} and ${to}`;
			}
			if (from) {
				return `from ${from}`;
			}
			if (to) {
				return `until ${to}`;
			}

			return "any time";
		}
	}

	const values = filter.values.map((value) => value.label).join(" or ");

	if (filter.valuesAreIncluded) {
		return values;
	}

	return `not ${values}`;
}

export const categoryToFilterValue = (
	category,
	selectionDepth = 1,
	excludedBranches = []
) => {
	// create a new FilterValue for all changes to break reactivity and this instant update on change
	return {
		id: null,
		model: category.model,
		rgb_color_value: "",
		label: category.label,
		level: category.level,
		selection_depth: selectionDepth,
		excluded_branches: excludedBranches,
	};
};
